import KnownActionsListPage from './KnownActionsListPage';

export default KnownActionsListPage;